export enum ViewState {
  NONE,
  OK,
  SUBMITTED,
  PRINTFAILED,
  ERROR,
  LOADING
}
